interface Args {
  name: string
  formValues: any
  version: number
}

export default function createResearchQueryPreset({post}: any, args: Args): Promise<any> {
  return post(`/comparable-sale-query-presets`, args, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/researchQueryPresets/createResearchQueryPreset.tsx